
import { AloDbUniteMobile } from '@/models/alodb/AloDbUniteMobile'
import { FilterBase } from '@/models/filter/FilterBase';

export interface IUniteMobileState {
    status:string
    uniteMobiles: Array<AloDbUniteMobile>
    modifiedAdmUniteMobile: AloDbUniteMobile
    originalAdmUniteMobile: AloDbUniteMobile
    uniteMobileLoading: boolean
    adminFilter: FilterBase
}
  
const state:IUniteMobileState = { 
    status: '',
    uniteMobiles: [],
    modifiedAdmUniteMobile: new AloDbUniteMobile(),
    originalAdmUniteMobile: new AloDbUniteMobile(),
    uniteMobileLoading:false,
    adminFilter: new FilterBase()
}
  
export default state